import isEmpty from 'lodash/isEmpty';
import clone from 'lodash/clone';
import isObject from 'lodash/isObject';
import map from 'lodash/map';

export function translate(intl, listObj, translatedField = 'name', type) {
  if(intl && isObject(listObj) && !Array.isArray(listObj)) {
    const listArray = map(listObj, (value, key) => {
      return {
        _id: key,
        ...value
      }
    });
    return listArray.map(obj => {
      const { _id, id, defaultMessage } = obj;
      const originalFields = clone(obj);
      delete originalFields.id;
      delete originalFields.defaultMessage;

      if (isEmpty(id)) {
        return {
          ...originalFields, 
          [translatedField]: defaultMessage
        }
      }

      if(type==='preference'){
        return {
          ...originalFields,
          [translatedField]: intl.formatMessage({ id, defaultMessage }),
        };
      }
      
      return {
        value: _id,
        [translatedField]: intl.formatMessage({ id, defaultMessage }),
        ...originalFields
      };
    });
  }
  return [];
};


export function translateData(intl, listArray, displayFn) {
  if(Array.isArray(listArray)) {
    return listArray.map(obj => {
      return {
        ...obj,
        name: intl.formatMessage({
          id: obj.key,
          defaultMessage: displayFn ? displayFn(obj) : obj.name
        })
      };
    });
  }
  return [];
}